function base64DecodeUnicode({ base64 }: { base64: string }) {
	return decodeURIComponent(
		atob(base64)
			.split("")
			.map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
			.join("")
	);
}

function decode({ token }: { token: string }): any {
	const tokenParts = token.split(".");
	const tokenPayload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
	const tokenPayloadDecoded = base64DecodeUnicode({ base64: tokenPayload });
	return JSON.parse(tokenPayloadDecoded);
}

export const JwtUtil = { decode };
